import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetUserGroupDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER_GROUP.GET_DETAIL + params, null);

export const GetUserGroupList = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER_GROUP.GET_LIST + params, null);

export const GetUserGroupListForSelect = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER_GROUP.GET_LIST_FOR_SELECT + params, null);

export const CreateUserGroup = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER_GROUP.CREATE, data);

export const UpdateUserGroup = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER_GROUP.UPDATE, data);

export const DeleteUserGroup = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER_GROUP.DELETE, data);

export const GetUserGroupMemberList = (params: any) =>
  GET_ENC(API_ENDPOINTS.USER_GROUP.GET_MEMBER_LIST + params, null);

export const TransferMembersToAnotherUserGroup = (data: any) =>
  POST_ENC(API_ENDPOINTS.USER_GROUP.TRANSFER_MEMBERS, data);

